
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { RcsWizardStepId } from '@/types/rcs-onboarding';

export default defineComponent({
  name: 'RcsOnboardingProgress',

  props: {
    stepNumber: { type: Number, required: true },
    steps: { type: Array as () => RcsWizardStepId[], required: true },
    currentStep: { type: String as () => RcsWizardStepId, required: true },
  },

  setup(props) {
    const { t } = useI18n();
    const totalSteps = computed(() => props.steps.length);
    const percent = computed(() => (
      totalSteps.value > 0
        ? Math.round((props.stepNumber / totalSteps.value) * 100)
        : 0
    ));
    const label = computed(() => t(
      'storeParameters.services.rcsServiceParameter.nav.progress',
      { current: props.stepNumber, total: totalSteps.value },
    ));
    const labelsByStep: Record<RcsWizardStepId, string> = {
      basic_info: t('storeParameters.services.rcsServiceParameter.nav.steps.basicInfo'),
      carrier_selection: t('storeParameters.services.rcsServiceParameter.nav.steps.carrierSelection'),
      visual: t('storeParameters.services.rcsServiceParameter.nav.steps.visual'),
      representative: t('storeParameters.services.rcsServiceParameter.nav.steps.representative'),
      carrier_requirements: t('storeParameters.services.rcsServiceParameter.nav.steps.carrierRequirements'),
      test_numbers: t('storeParameters.services.rcsServiceParameter.nav.steps.testNumbers'),
    };
    const steps = computed(() => props.steps.map((id) => ({
      id,
      label: labelsByStep[id],
    })));
    return {
      totalSteps,
      percent,
      label,
      steps,
    };
  },
});
